import { Box } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../../actions/arts";
import { clearAllProviders, getAllProviders, getProviderStatistics } from "../../../../actions/providers";
import ProviderStatsSearchComponent from "./providerStatsSearch";
import ProviderStatsTable from "./providerStatsTable";

const ProviderStatsContainer = () => {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState({ art: "", provider: "", fechaDesde: null, fechaHasta: null });

    const providerStatistics = useSelector((state) => state.providers.providerStatistics);
    const arts = useSelector((state) => state.arts);
    const providers = useSelector((state) => state.providers.allProvidersOptions);

    useEffect(() => {
        dispatch(getArts());
    }, [dispatch]);

    const handleSearch = (art, provider, fechaDesde, fechaHasta) => {
        setSearchQuery({ art, provider, fechaDesde, fechaHasta });
        const startOfFechaDesde = fechaDesde ? moment(fechaDesde).startOf('day').toISOString() : null;
        const endOfFechaHasta = fechaHasta ? moment(fechaHasta).endOf('day').toISOString() : null;
        dispatch(getProviderStatistics(art, provider, startOfFechaDesde, endOfFechaHasta));
    };

    const handleReset = () => {
        setSearchQuery({ art: "", provider: "", fechaDesde: null, fechaHasta: null });
    };

    const handleArtChange = (artValue) => {
        if (artValue) {
            dispatch(getAllProviders(artValue.id));
        } else {
            dispatch(clearAllProviders());
        }
    };

    return (
        <Box sx={{ padding: '16px' }}>
            <ProviderStatsSearchComponent
                handleSearch={handleSearch}
                handleReset={handleReset}
                art={arts.list}
                providers={providers.data}
                onArtChange={handleArtChange}
            />
            <Box sx={{ marginTop: '24px' }}>
                <ProviderStatsTable
                    data={providerStatistics.data.results}
                    loading={providerStatistics.isFetching}
                    fetchData={() => dispatch(getProviderStatistics(searchQuery.art, searchQuery.provider))}
                />
            </Box>
        </Box>
    );
};

export default ProviderStatsContainer;
